(() => {
if (window.achakiCountdownReady) return;
window.achakiCountdownReady = true;
const states = new WeakMap();
function tick() {
const now = Date.now();
document.querySelectorAll('[data-achaki-countdown]').forEach(el => {
const duration = Math.max(1, Math.min(72, Number(el.dataset.hours) || 4)) * 3600000;
let state = states.get(el);
if (!state) {
const key = 'achaki-countdown-v1:' + el.dataset.productId + ':' + duration;
let end;
try { end = Number(localStorage.getItem(key)); } catch (_) {}
if (!Number.isFinite(end) || end <= 0 || end > now + duration) end = now + duration;
state = { key, end, duration };
states.set(el, state);
try { localStorage.setItem(key, String(state.end)); } catch (_) {}
}
if (state.end <= now) {
state.end += (Math.floor((now - state.end) / state.duration) + 1) * state.duration;
try { localStorage.setItem(state.key, String(state.end)); } catch (_) {}
}
const seconds = Math.max(0, Math.ceil((state.end - now) / 1000));
const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
Object.entries(values).forEach(([unit,value]) => { const node = el.querySelector('[data-' + unit + ']'); const text = String(value).padStart(2,'0'); if (node && node.textContent !== text) node.textContent = text; });
});
}
tick();
setInterval(tick, 1000);
document.addEventListener('shopify:section:load', tick);
document.addEventListener('visibilitychange', tick);
window.addEventListener('pageshow', tick);
})();